import { render, staticRenderFns } from "./VastuualueView.vue?vue&type=template&id=992f7748&xmlns%3Av-touch=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./VastuualueView.vue?vue&type=script&lang=js"
export * from "./VastuualueView.vue?vue&type=script&lang=js"
import style0 from "./VastuualueView.vue?vue&type=style&index=0&id=992f7748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports